module.exports = __webpack_public_path__ + "media/images/admin/cropping-2x1-dc25dfab25f697912b9cc8883e806d12.webp";